<section class="preview-wrapper position-relative" [class.hidden]="modalHidden" [ngClass]="[fileMode]">
  <button mat-fab class="close-button d-block d-lg-none" aria-label="Close" mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>

  @if (!isSizeLimitExceeded) {
    <app-document-preview
      [entityId]="data.entityId"
      [fileKey]="data.file?.key || data.file?.uri"
      [insideDialog]="true"
      [fileName]="data.file.filename"
      [uri]="data.presignedUrl"
      [provider]="data.file.provider"
      [disableDownload]="!data.isFileDownloadEnabled"
      (isLoaded)="loaded($event)">
    </app-document-preview>
  }
  @if (!isLoaded) {
    <mat-progress-bar mode="indeterminate" class="progress-bar"></mat-progress-bar>
  }

  @if (isSizeLimitExceeded) {
    <div class="file-too-large-wrapper">
      <div class="file-too-large-message">{{'LIBRARY.file_too_large_download_directly' | translate}}</div>
      <div>{{data.file.filename}}</div>
      <button mat-flat-button class="button button--large button--primary" (click)="download()">{{'COMMON.download' | translate}}</button>
    </div>
  }
</section>
